"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _RedirectToExternalSite = require("../../utils/RedirectToExternalSite");

var _RedirectToExternalURL = require("./RedirectToExternalURL.scss");

var _RedirectToExternalURL2 = _interopRequireDefault(_RedirectToExternalURL);

var _components = require("components");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedirectToExternalURL = function (_React$PureComponent) {
  (0, _inherits3.default)(RedirectToExternalURL, _React$PureComponent);

  function RedirectToExternalURL(props) {
    (0, _classCallCheck3.default)(this, RedirectToExternalURL);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RedirectToExternalURL.__proto__ || (0, _getPrototypeOf2.default)(RedirectToExternalURL)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(RedirectToExternalURL, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var returnToUrl = (0, _RedirectToExternalSite.getReturnToUrl)();
      this.setState({
        returnToUrl: returnToUrl
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: "Oops! You are redirecting to external site!" },
        _react2.default.createElement(
          "section",
          null,
          _react2.default.createElement(_components.SiteHeaderGap, null),
          _react2.default.createElement(
            "div",
            { className: _RedirectToExternalURL2.default.mainContainer },
            _react2.default.createElement(
              "div",
              { className: _RedirectToExternalURL2.default.noneFoundMessage },
              _react2.default.createElement(
                "svg",
                {
                  width: "96",
                  height: "96",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                },
                _react2.default.createElement("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M10.4806 5.14738C11.1524 3.97171 12.8476 3.9717 13.5194 5.14738L19.7962 16.1318C20.4629 17.2985 19.6205 18.7501 18.2768 18.7501H5.72317C4.37948 18.7501 3.53708 17.2985 4.20374 16.1318L10.4806 5.14738Z",
                  fill: "white",
                  "fill-opacity": "0.5"
                }),
                _react2.default.createElement("path", {
                  d: "M12 9V12",
                  stroke: "#242424",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _react2.default.createElement("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M10.75 15C10.75 14.3096 11.3096 13.75 12 13.75C12.6904 13.75 13.25 14.3096 13.25 15C13.25 15.6904 12.6904 16.25 12 16.25C11.3096 16.25 10.75 15.6904 10.75 15Z",
                  fill: "#242424"
                })
              ),
              _react2.default.createElement(
                "span",
                { className: _RedirectToExternalURL2.default.boldText },
                "HOLD UP"
              ),
              _react2.default.createElement(
                "span",
                { className: _RedirectToExternalURL2.default.normalText },
                "This link will take you to",
                _react2.default.createElement(
                  "span",
                  { className: _RedirectToExternalURL2.default.normalBoldText },
                  this.state.returnToUrl
                ),
                "Are you sure you want to go there?"
              ),
              _react2.default.createElement(
                "div",
                { className: _RedirectToExternalURL2.default.container },
                _react2.default.createElement(_Button2.default, {
                  mode: "transparentWithGrayBorder",
                  label: "GO BACK",
                  to: "/login"
                }),
                _react2.default.createElement(_Button2.default, {
                  mode: "secondary",
                  label: "Continue",
                  href: this.state.returnToUrl
                })
              )
            )
          )
        )
      );
    }
  }]);
  return RedirectToExternalURL;
}(_react2.default.PureComponent);

exports.default = RedirectToExternalURL;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/RedirectToExternalURL/RedirectToExternalURL.jsx
// module id = 2910
// module chunks = 0